module.exports = __webpack_public_path__ + "static/10-33125a2de676d1f9d95b8c9e6a666f32.jpg";